// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3erd3","footer":"styles_footer__2cqr8","passCodeTooltip":"styles_passCodeTooltip__rnGn3"};